import React, { useCallback, useState } from 'react';

import SmallButtonStyled from '../../../components/Buttons/SmallButtonStyled';
import ConfirmationModal from '../../../components/ConfirmationModal';
import { formattedDateTime } from '../../../utils/date';
import { PartnerKey } from '../styledComponents';
import doFetch from '../../../api/doFetch';

export default function ({ client, onDelete }) {
  const [isOpenConfirm, setIsOpenConfirmModal] = useState(false);

  const toggleModal = useCallback(() => setIsOpenConfirmModal(!isOpenConfirm), [isOpenConfirm]);

  const handleDelete = useCallback(async () => {
    const { id, partnerId } = client;
    const url = `/lotlenz/partners/${partnerId}/oauth-clients/${id}`;
    await doFetch(url, { method: 'DELETE' });

    onDelete(client);
  }, [client, onDelete]);

  return (
    <PartnerKey>
      <div className='title'>
        {client.clientId}
        <div className='scope'>
          <b>Scopes: </b>
          {client.scopes.join(' ')}
        </div>
      </div>
      <div>{formattedDateTime(client.createdAt)}</div>
      <SmallButtonStyled className='btn' onClick={toggleModal}>
        Revoke
      </SmallButtonStyled>
      <ConfirmationModal
        title={'REVOKE ACCESS KEY'}
        text={
          'This credentials will be permanently revoked. If no other active credentials remain, the partner will lose access to the system.'
        }
        isOpen={isOpenConfirm}
        toggleHandler={toggleModal}
        confirmAction={handleDelete}
      />
    </PartnerKey>
  );
}
